/* angular:styles/component:css;d1a91cebd51582d39bcba7dccab89ed15654c5a08010c5d8261869d8b7d5b435;/home/darknd/Documents/GitHub/convfact-webapp/src/app/modules_v2/booking/locations/components/sections/location-general-section/slug-onboarding-dialog.component.ts */
.onboarding-icon {
  font-size: 48px;
  color: var(--cf-brand-dark);
}
.example-url {
  background: #f5f5f5;
  border-radius: 6px;
  padding: 8px 12px;
  font-family: monospace;
  font-size: 13px;
  word-break: break-all;
}
.highlight {
  color: var(--cf-brand-dark);
  font-weight: bold;
}
/*# sourceMappingURL=slug-onboarding-dialog.component.css.map */
